import { render, staticRenderFns } from "./msg-reply-rule-add-or-update.vue?vue&type=template&id=583a3afa&"
import script from "./msg-reply-rule-add-or-update.vue?vue&type=script&lang=js&"
export * from "./msg-reply-rule-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports